autocomplete 是一个可带输入建议的下拉框组件

<template>
  <el-form-item :label="title" :id="field.FIELD_ID" :ref="field.FIELD_ID" :class="[
      itemClass,
      field.DEFAULT_VALUE != '' ? 'is-selected' : 'no-selected',
    ]" v-if="isShow" :prop="field.FIELD_ID" :rules="rules">
    <div class="select">
      <el-autocomplete popper-class="self-autocomplete" v-model="field.DEFAULT_VALUE" value-key="label"
        :disabled="isDisabled" :placeholder="field.PLACE_HOLDER" :fetch-suggestions="dataFilter" @select="handleSelect"
        @blur="handleBlur" @focus="handleFocus">
        <template slot-scope="props">
          <span class="label">{{ props.item.label }}</span>
        </template>
      </el-autocomplete>
    </div>
  </el-form-item>
</template>

<script>
import oppService from "../../service/opp-service";
import stringPinyinConfig from "@/tools/stringPinyinConfig.js"; // 拼音处理插件

export default {
  data () {
    return {
      itemClass: "self-selector allow-keyboard-input",
      options: [],
      all_options: [],
      isDisabled: false,
      triggerType: "custom",
      rules: [],
    };
  },
  props: ["field", "index", "groupId", "isBaseUI", "selectChange"],
  filters: {
    DICT_NAME: function (value) {
      if (!value) return "";
    },
  },
  created () {
    this.rules.push({
      validator: this.validatorField,
      trigger: this.triggerType,
    });
  },
  mounted () {
    this.itemClass += " " + this.field.FIELD_ID;

    if (this.isRequired) this.itemClass += " self-selector-required";

    if (this.isShowChange) this.itemClass += " self-selector-changed";

    if (this.allowCreate) this.itemClass += " self-selector-create";

    if (this.isShowButton) this.itemClass += " self-selector-use-id-button";

    this.initDict();
  },
  computed: {
    //是否允许用户创建条目
    allowCreate: function () {
      return this.field.FIELD_ALLOW_CREATE ? true : false;
    },
    allowFilter: function () {
      return this.field.FIELD_ALLOW_FILTER ? true : false;
    },
    title: function () {
      this.field.FIELD_TITLE = this.field.FIELD_TITLE.replace("\\n", "\n");
      return _.trim(this.field.FIELD_TITLE)
        ? this.field.FIELD_TITLE +
        (_.intersection(this.field.FIELD_TITLE.split(""), ["：", ":"])
          .length
          ? ""
          : "：")
        : "";
    },
    isRequired: function () {
      return parseInt(this.field.FIELD_REQUIRED) ? true : false;
    },
    isShow: function () {
      let fieldControl = parseInt(this.field.FIELD_CONTROL);
      if (fieldControl == 2) {
        this.isDisabled = true;
      } else {
        this.isDisabled = false;
      }
      if (this.isShowButton) {
        this.isDisabled = true;
      }
      if (fieldControl === 0 || fieldControl === 2) {
        return true;
      } else {
        return false;
      }
    },
    dictFilterChange: function () {
      return this.field.FIELD_DICT_FILTER;
    },
    dictNameChange: function () {
      return this.field.FIELD_DICT_NAME;
    },
    dataChange: function () {
      return this.field.DEFAULT_VALUE;
    },
    messageChange: function () {
      return this.field.message;
    },
    isShowChange: function () {
      return this.field.showchange;
    },
    isShowButton: function () {
      return this.field.IS_SHOW_BUTTON;
    },
  },
  methods: {
    initDict () {
      if (this.field.FIELD_DICT_NAME && this.field.FIELD_DICT_NAME != "") {
        this.options = [];
        this.all_options = []; //需要清空 如更新字典，dataFilter会出现重复内容
        let showArr;
        try {
          let filter = eval(this.field.FIELD_DICT_FILTER);
          if (filter.constructor == Array) {
            showArr = filter;
          } else {
            showArr = [];
          }
        } catch (exception) {
          showArr = [];
        }

        _.forEach(this.field.FIELD_DICT_NAME, (item) => {
          // 判断机构ORG_CODE TODO
          //默认显示字典名称
          let newName = item.DICT_ITEM_NAME;
          if (
            oppService.getSysCommonParamsFromCacheObjs(
              "APP_SHOW_KEY_AND_VALUE"
            ) == "1"
          ) {
            //如果系统公参设置了显示key值跟value值，则显示字典值加上字典名称
            newName = item.DICT_ITEM + "-" + item.DICT_ITEM_NAME;
          }
          let obj = { value: item.DICT_ITEM, label: newName };
          if (
            !showArr.length ||
            showArr.length == this.field.FIELD_DICT_NAME.length
          ) {
            //如果不用过滤,直接添加
            this.options.push(obj);
            this.all_options.push(obj);
          } else {
            //如果需要过滤，则满足条件添加
            if (showArr && showArr.indexOf(item.DICT_ITEM) !== -1) {
              this.options.push(obj);
              this.all_options.push(obj);
            }
          }
        });
      }
    },
    validatorField: function (rule, value, callback) {
      //隐藏的字段不校验
      // if(!this.isShow){
      //   return;
      // }
      value = this.field.DEFAULT_VALUE;
      if (_.trim(value) === "" && this.isRequired && this.isShow) {
        this.showErrorMsg = this.field.FIELD_TITLE + "为必填项";
        this.field.correct = false;
        this.field.showerr = true;
        this.field.FIELD_CONTROL = "0";
        return callback(new Error(this.showErrorMsg));
      } else if (this.field.message) {
        // 关联逻辑判断中传过来要显示的message
        this.showErrorMsg = this.field.message;
        this.field.correct = false;
        this.field.showerr = true;
        return callback(new Error(this.showErrorMsg));
      } else {
        this.field.correct = true;
        this.showErrorMsg = "";
        this.field.message = "";
        this.field.showerr = false;
        if (this.isBaseUI) {
          this.$emit("field-change", this.field);
        } else {
          this.$store.commit(this.$types.UPDATE_FIELD_CHANGE, {
            field_id: this.field.FIELD_ID,
            module_id: this.field.MODULE_ID,
            index: this.index,
          });
        }
        return callback();
      }
    },
    //使用证件地址 按钮
    useSelectButton: function () {
      if (this.isBaseUI) {
        this.$emit("use-id-button", this.field);
      } else {
        //更改state的值，触发全局的字段赋值事件
        let data = {};
        data["FIELD_ID"] = this.field.FIELD_ID;
        data["GROUP_ID"] = this.groupId;
        data["MODULE_ID"] = this.field.MODULE_ID;
        data["index"] = "0";
        this.$store.commit(this.$types.UPDATE_COMPONENT_BUTTON_CLICK, data);
      }
    },
    handleSelect (val) {
      this.$emit("selectChange", val);
    },
    handleBlur () {
      // 这里添加了失去焦点判断是否匹配 如不匹配则清空输入值
      let defaultVal = this.field.DEFAULT_VALUE,
        match = _.find(this.field.FIELD_DICT_NAME, function (v) {
          return v.DICT_ITEM_NAME === defaultVal;
        });
      if (_.isEmpty(match)) {
        this.field.DEFAULT_VALUE = "";
      }
    },
    handleFocus () { },
    dataFilter (val, cb) {
      let result = [];
      let options = this.all_options;
      // 中文匹配
      if (/[\u4e00-\u9fa5]+/.test(val)) {
        let arr = options.filter((item) => {
          return item.label.includes(val);
        });
        result = result.concat(arr);
      } else {
        //非中文匹配
        let upperSearchBoxText = val.toUpperCase();
        let arr = options.filter((item) => {
          let pinyin = stringPinyinConfig
              .ConvertPinyin(item.label)
              .toUpperCase(),
            firstCapital = stringPinyinConfig
              .getAllFirstCapital(item.label)
              .toUpperCase();

          return (
            pinyin.includes(upperSearchBoxText) ||
            firstCapital.includes(upperSearchBoxText)
          );
        });
        result = result.concat(arr);
      }
      this.options = val === "" ? options : result;
      cb(this.options);
    },
  },
  watch: {
    isRequired: function (val) {
      if (val) {
        this.itemClass += " self-selector-required";
      } else {
        this.itemClass = this.itemClass.replace(/self-selector-required/g, "");
      }
    },
    isShowChange: function (val) {
      if (val) {
        this.itemClass += " self-selector-changed";
      } else {
        this.itemClass = this.itemClass.replace(/self-selector-changed/g, "");
      }
    },
    dictFilterChange: function (val) {
      this.initDict();
    },
    dictNameChange: function (val) {
      this.initDict();
    },
    messageChange: function (val) {
      // if(val){
      this.$refs[this.field.FIELD_ID].validate("custom"); // 自定义触发校验事件
      // }
    },
    dataChange: function (val) {
      this.field.message = "";
      this.$refs[this.field.FIELD_ID].validate("custom"); // 自定义触发校验事件
    },
  },
};
</script>

<style lang="less">
.self-selector {
  width: 100%;
  display: flex;
  .el-form-item__label {
    font-size: 14px;
    min-width: 170px;
    text-align: right;
  }
  .el-form-item__content {
    font-size: 14px;
    color: #000;
    flex: 1;

    .select {
      display: inline-flex;
      width: 100%;
      .el-autocomplete {
        width: 100%;
        .el-input__inner {
          padding-right: 50px;
        }
        .el-input__suffix {
          right: 20px;
          .el-select__caret {
            font-size: 19px;
            color: #bbbec2;
          }
        }
      }
      .street {
        display: inline-flex;
        flex: 3;
      }
      .el-button {
        background: #f9f9f9;
        flex: 0 0 80px;
        display: inline-flex;
        width: 120px;
        font-size: 16px;
      }
    }
  }
}

.self-selector-required {
  .el-form-item__label:before {
    content: "*";
    color: #f56c6c;
    margin-right: 4px;
  }
}

.self-selector-changed {
  input.el-input__inner {
    // background: rgba(252, 230, 56, 0.2) !important;
  }
}

.self-selector-use-id-button {
  .street .el-input__inner {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .el-button {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    border-left-width: 0;
  }
}

.self-autocomplete {
  &.el-autocomplete-suggestion li {
    height: 80px;
    // font-size: 28px;
    font-size: 16px;
    font-weight: 500;
    line-height: 80px;
    color: #232323;

    &:nth-child(odd) {
      background-color: #f3f5f7;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/preEntry/autoComplete.vue